import axios from "@/axios-service";
import { PicassoCollection } from './types';
import { responseContent } from "@/api/types";


const MS_URL = "senana/farm";
const responseParser = responseContent(PicassoCollection);


const getByUuid = async (uuid: string): Promise<PicassoCollection> => axios
  .get(`${MS_URL}/analysis/${uuid}/scene-images`,)
  .then(responseParser)
  .then(it => it.data);


const generate = async (uuid: string): Promise<any> => axios
  .post(`${MS_URL}/analysis/${uuid}/scene-images`);


export async function generateImages(uuid: string): Promise<any> {
  return await generate(uuid)
    .then(it => it.data);
}


export async function loadByUuid(uuid: string): Promise<PicassoCollection> {
  return await getByUuid(uuid);
}
